import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import './index.css'
import { initSentry } from '@/lib/sentry'
import { ErrorBoundary } from '@/components/ErrorBoundary'
import { initNativeServices } from '@/services/nativeService'
import { initAuthDeepLinkListener } from '@/services/authDeepLinkService'
import { checkForUpdate, confirmUpdate } from '@/services/liveUpdateService'

// Sentry hata takibini başlat (DSN yoksa sessizce devre dışı kalır)
initSentry()

// Capacitor native servislerini başlat (StatusBar, Haptics — web'de no-op)
initNativeServices()

// OAuth deep link dinleyicisini başlat (native'de custom URL scheme callback — web'de no-op)
initAuthDeepLinkListener()

// Live Update: Mevcut bundle'ı onayla (rollback koruması) + arka planda güncelleme kontrolü
confirmUpdate()
checkForUpdate()


ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </React.StrictMode>
)

